let SingleNews = (props) => {
    return(

        <div className="card text-center news">
            
            <div className="card-header newsHeader">
                <strong>{props.title}</strong>
            </div>
            
            <div className="card-body newsBody">
                <p className="card-text">{props.text}</p>
                {props.image ? <img className="newsImage" src={props.image} /> : ""}
            </div>
            
            <div className="card-footer text-muted newsFooter">
                <i>{props.author}, {props.date} </i>
            </div>
        </div>
    )
}

export default SingleNews;